import React from 'react'
import { useTranslation } from 'react-i18next'

export default function AspectRatioSVG() {
  const [t] = useTranslation()

  return (
    <svg fill="none" viewBox="-16 -24 316 249" height="225" overflow="visible">
      <rect fill="#D9D9D9" width={300} height={225} />
      <text x="50%" y="50%" fill="#000" dominantBaseline="middle" textAnchor="middle">
        {t('groups.upload-aspect-ratio.label', 'Aspect Ratio')}
      </text>
      <text x="50%" y="-8" fill="#000">
        4
      </text>
      <text x="-16" y="50%" fill="#000">
        3
      </text>
    </svg>
  )
}
